module.exports = __webpack_public_path__ + "img/live-banner.a0b959db.png";